import { Avatar } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { IconX, IconCheck } from "@tabler/icons";

export const alertNotify = (Title) => {
  showNotification({
    icon: <IconX size={22} />,
    color: "red",
    title: Title,
    disallowClose: true,
    styles: () => ({
      title: {
        fontSize: 20,
      },
    }),
  });
};
export const checkNotify = (title) => {
  showNotification({
    icon: <IconCheck size={22} />,
    color: "teal",
    title: title,
    disallowClose: true,
    styles: () => ({
      title: {
        fontSize: 20,
      },
    }),
  });
};
export const trueInsert = (Photo, Name, PhoneNumber) => {
  showNotification({
    icon: <Avatar src={Photo} radius={50} />,
    title: `تمت اضافة الشخص`,
    message: `${Name}\n${PhoneNumber} `,
    disallowClose: true,
    styles: () => ({
      title: {
        fontSize: 20,
      },
    }),
  });
};
